import React from 'react';
import { Clock } from 'lucide-react';

const Navbar = ({ title = "Dashboard", admitted_patients, assigned_devices, discharged_patients, lastUpdated }) => {

  const formatIST = (timestamp) => {
    if (!timestamp) return 'N/A';
    return new Date(timestamp).toLocaleString('en-IN', {
      timeZone: 'Asia/Kolkata',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: true,
    });
  };

  const stats = [
    {
      label: 'Active Patients',
      value: admitted_patients,
      dot: 'bg-emerald-500',
      ring: 'bg-emerald-50 text-emerald-700 border-emerald-100',
      pulse: true,
    },
    {
      label: 'Disconnected Devices',
      value: assigned_devices,
      dot: 'bg-amber-500',
      ring: 'bg-amber-50 text-amber-700 border-amber-100',
    },
    {
      label: 'Discharged Today',
      value: discharged_patients,
      dot: 'bg-slate-400',
      ring: 'bg-slate-50 text-slate-600 border-slate-200',
    },
  ];

  return (
    <nav className="bg-white shadow-card rounded-2xl border border-gray-100 md:my-6 md:mx-4">
      <div className="px-4 md:px-6 py-4 flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
        <div className="flex flex-wrap items-center gap-2 md:gap-3">
          {stats.map((s) => (
            <div
              key={s.label}
              className={`flex items-center gap-2 pl-2.5 pr-3 py-1.5 rounded-full border text-sm font-medium ${s.ring}`}
            >
              <span className={`w-2 h-2 rounded-full ${s.dot} ${s.pulse ? 'animate-pulse-ring' : ''}`}></span>
              <span>{s.label}</span>
              <span className="font-bold tabular-nums">{s.value}</span>
            </div>
          ))}
        </div>
        <div className="flex items-center text-xs md:text-sm text-gray-500">
          <Clock className="h-4 w-4 mr-1.5 text-brand-600" />
          <span className="font-semibold text-gray-600 mr-1 hidden md:inline">Last Updated:</span>
          <span className="font-medium tabular-nums">{formatIST(lastUpdated)}</span>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;